import { getConfigOrThrow } from 'gossamer-front-end';
import React, { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { EventVideoRecordingPlayer } from '../EventVideoRecordingPlayer';
import { Play, Download } from 'lucide-react';

interface EventVideoRecordingViewProps {
  livestreamSessionId: string;
}

export const EventVideoRecordingView = (props: EventVideoRecordingViewProps) => {
  const [show, setShow] = React.useState(false);
  const [hasRecording, setHasRecording] = React.useState(false);
  const [hasFile, setHasFile] = React.useState(false);
  const livestreamBaseUrl = `${getConfigOrThrow('gossamer-be-origin')}/gossamer/main/livestream`;

  useEffect(() => {
    if (props.livestreamSessionId) {
      (async () => {
        const response = await fetch(`${livestreamBaseUrl}/recordings/${props.livestreamSessionId}/status`, {
          credentials: 'include',
        });
        const statusResponse = await response.json();
        setHasRecording(statusResponse?.playlist || false);
        setHasFile(statusResponse?.file || false);
      })();
    }
  }, [livestreamBaseUrl, props.livestreamSessionId]);

  return (
    props.livestreamSessionId && (
      <>
        <Button
          disabled={!hasRecording}
          className="d-flex justify-content-start  align-items-center gap-1"
          variant="outline-secondary"
          size="sm"
          onClick={() => setShow(true)}
        >
          <Play size={14} />
          View Recording
        </Button>
        {hasFile && (
          <Button
            as="a"
            className="d-flex justify-content-start  align-items-center gap-1"
            href={`${livestreamBaseUrl}/recordings/${props.livestreamSessionId}/file`}
            target="_blank"
            rel="noopener noreferrer"
            disabled={!hasFile}
            variant="secondary"
            size="sm"
          >
            <Download size={14} />
            Download
          </Button>
        )}
        {hasRecording && (
          <Modal
            show={show}
            size="lg"
            onHide={() => setShow(false)}
            aria-labelledby="event-recording-modal"
            fullscreen="sm-down"
            centered
          >
            <Modal.Header className="pb-0 border-bottom-0" closeButton></Modal.Header>
            <Modal.Body>
              <EventVideoRecordingPlayer src={`${livestreamBaseUrl}/recordings/${props.livestreamSessionId}/stream`} />
            </Modal.Body>
          </Modal>
        )}
      </>
    )
  );
};
